import { useCallback, useEffect, useRef } from "react"
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"

export interface ReplaceSkillConfirmDialogProps {
  open: boolean
  skillName: string
  onClose: () => void
  onConfirm: () => void
}

export function ReplaceSkillConfirmDialog({ open, skillName, onClose, onConfirm }: ReplaceSkillConfirmDialogProps) {
  const hasConfirmed = useRef(false)
  useEffect(() => {
    if (open) hasConfirmed.current = false
  }, [open])

  const handleConfirm = useCallback(() => {
    if (hasConfirmed.current) return
    hasConfirmed.current = true
    onConfirm()
  }, [onConfirm])

  return (
    <Dialog open={open} onClose={onClose} data-testid="kelly-skill-replace-dialog">
      <DialogTitle>{`Replace "${skillName}"?`}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {`You already have a skill called "${skillName}". Confirming replaces its contents with this version. Whether it is switched on for Kelly stays as you have it.`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleConfirm} color="warning" data-testid="kelly-skill-replace-confirm">Replace</Button>
      </DialogActions>
    </Dialog>
  )
}
